import uploadTreatmentPlanConstants from '@constants/uploadTreatmentPlan.constants'

export default [
  {
    value: uploadTreatmentPlanConstants.TREATMENT_PLANNING_LINK,
    label: 'Treatment planning link',
  },
  {
    value: uploadTreatmentPlanConstants.UPLOAD_SINGLE_VIDEO,
    label: 'Upload single video',
  },
  {
    value: uploadTreatmentPlanConstants.UPLOAD_MULTIPLE_VIDEOS,
    label: 'Upload multiple videos',
  },
  {
    value: uploadTreatmentPlanConstants.UPLOAD_PDF,
    label: 'Upload PDF',
  },
  {
    value: uploadTreatmentPlanConstants.DO_NOT_UPLOAD,
    label: "Don't upload",
  },
]
